export enum SocialAccountType {
    facebook,
    twitter,
    telegram
}

export interface SocialAccountModel {
    id: number;
    type: SocialAccountType;
    name: string;
    url: string;
    isPrimary: boolean;
}